// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1_GaT","insightsList":"newBusinessInsightsMenu_insightsList__3WmFO","active":"newBusinessInsightsMenu_active__2WRum"};